import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import PartnerLogos from "@/components/shared/PartnerLogos";
import CTASection from "@/components/shared/CTASection";
import PageSEO from "@/components/shared/PageSEO";
import StatsCounter from "@/components/shared/StatsCounter";

const Index = () => {
  const homeJsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "SDC - Sustainable Mobility Saudi Arabia",
      "description": "Leading micro mobility supplier and distributor in Saudi Arabia providing B2B B2G mobility solutions aligned with Vision 2030. موزع الميكرو موبيليتي الرائد في السعودية.",
      "url": "https://gulf-spark-rebuild.lovable.app/",
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is micro mobility? ما هو الميكرو موبيليتي؟",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Micro mobility refers to lightweight electric vehicles like scooters, e-bikes, patrol carts, and electric unicycles designed for short-distance urban transportation. SDC is the leading micro mobility supplier in Saudi Arabia. الميكرو موبيليتي يشير إلى المركبات الكهربائية الخفيفة مثل السكوترات والدراجات الكهربائية وعربات الدورية المصممة للتنقل الحضري القصير المسافة."
          }
        },
        {
          "@type": "Question",
          "name": "Where to buy electric scooters in Saudi Arabia? أين يمكن شراء سكوتر كهربائي في السعودية؟",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "SDC (تطوير الاستدامة) is the authorized distributor of electric scooters, patrol vehicles, and micro mobility solutions in Saudi Arabia. We serve businesses and government entities across Jeddah, Riyadh, Dammam, and NEOM with B2B and B2G fleet solutions."
          }
        },
        {
          "@type": "Question",
          "name": "Who supplies electric patrol vehicles in KSA? من يوفر مركبات الدورية الكهربائية في السعودية؟",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "SDC Gulf (تطوير الاستدامة) supplies electric patrol vehicles including the iTank, iTango, and customized patrol carts for security, police, and government operations across Saudi Arabia. We provide full fleet customization, branding, and maintenance support."
          }
        },
        {
          "@type": "Question",
          "name": "What micro mobility solutions are available for Vision 2030 projects?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "SDC provides comprehensive micro mobility solutions aligned with Vision 2030 including electric fleet deployment for smart cities, event mobility management, last-mile delivery solutions, and sustainable transportation infrastructure for mega projects like NEOM and Jeddah developments."
          }
        }
      ]
    }
  ];

  return (
    <main className="min-h-screen bg-background">
      <PageSEO
        title="Micro Mobility Supplier Saudi Arabia"
        description="SDC تطوير الاستدامة - Leading micro mobility supplier & distributor in Saudi Arabia. Electric vehicles, patrol carts, scooters & fleet solutions for B2B B2G. موزع الميكرو موبيليتي في السعودية. Vision 2030 aligned."
        keywords="micro mobility Saudi Arabia, ميكرو موبيليتي السعودية, تنقل صغير, electric vehicles KSA, مركبات كهربائية, سكوتر كهربائي, electric scooter distributor Saudi Arabia, patrol vehicles KSA, B2B mobility, B2G fleet solutions, sustainable transportation, رؤية 2030, e-mobility Vision 2030, last mile delivery Saudi Arabia, دراجات كهربائية السعودية, electric fleet solutions KSA, عربات كهربائية"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <Hero />
      <Services />
      <StatsCounter />
      <About />
      <PartnerLogos title="Trusted By Industry Leaders" />
      <Contact />
      <CTASection
        title="Ready to Transform Your Mobility?"
        description="Partner with us for innovative, sustainable transportation solutions aligned with Vision 2030."
        primaryButtonText="Get Started"
        primaryButtonLink="/contact"
        secondaryButtonText="Explore Services"
        secondaryButtonLink="/services"
      />
      <Footer />
    </main>
  );
};

export default Index;
